<template>
  <div v-if="users.length" class="stat-list">
    <div v-for="u in users" :key="u.userKey" class="stat-row">
      <div
        class="stat-avatar"
        :style="{ backgroundColor: avatarColor(u.name, u.color) }"
      >
        {{ avatarLetter(u.name) }}
      </div>
      <div class="stat-label">
        <strong>
          {{ u.name }}
          <span
            :class="[
              'stat-badge',
              u.isModerator ? 'stat-badge--moderator' : 'stat-badge--viewer',
            ]"
          >
            {{ u.isModerator ? 'Moderator' : 'Viewer' }}
          </span>
        </strong>
        <div class="stat-meta">
          <span class="stat-meta-item">
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            {{ fmtDur(talkMs(u)) }} talk
          </span>
          <span class="stat-meta-item">
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              />
            </svg>
            {{ u.totalOfMessages || 0 }} msg
          </span>
          <span v-if="sessionMs(u) > 0" class="stat-meta-item">
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
            </svg>
            {{ fmtDur(sessionMs(u)) }} session
          </span>
        </div>
      </div>
      <div v-if="talkMs(u) > 0" class="stat-value">
        {{ fmtDur(talkMs(u)) }}
      </div>
    </div>
  </div>
  <div v-else class="empty-state">
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <p>No participants recorded.</p>
  </div>
</template>

<script>
import { avatarColor, avatarLetter, fmtDur, sessionTimeMs } from './helpers.js';

export default {
  name: 'UsersTab',
  props: {
    users: { type: Array, default: () => [] },
    endedOn: { type: Number, default: 0 },
  },
  methods: {
    avatarColor,
    avatarLetter,
    fmtDur,
    talkMs(u) {
      return (u && u.talk && u.talk.totalTime) || 0;
    },
    sessionMs(u) {
      return sessionTimeMs(u, this.endedOn);
    },
  },
};
</script>
